export const INTRO_HOLD=1.2;
export const INTRO_FADE=0.8;
export const INTRO_DURATION=INTRO_HOLD+INTRO_FADE;

// The opening card uses wall-clock seconds, independently of play speed.
export function presentationTiming(seconds,{intro=false,speed=1,duration=0}={}){
  const opening=intro?INTRO_DURATION:0;
  return {
    duration:opening+duration/speed,
    playTime:Math.max(0,seconds-opening)*speed,
    introOpacity:intro?Math.max(0,Math.min(1,(opening-seconds)/INTRO_FADE)):0
  };
}

function wrapTitle(ctx,text,maxWidth){
  const lines=[];let line='';
  for(const word of text.split(/\s+/)){
    if(line && ctx.measureText(line+' '+word).width>maxWidth){lines.push(line);line='';}
    // Long words also fit inside the card.
    for(const letter of (line?' ':'')+word){
      if(line && ctx.measureText(line+letter).width>maxWidth){lines.push(line);line='';}
      line+=letter;
    }
  }
  if(line)lines.push(line);
  return lines;
}

export function drawPresentation(ctx,{width,height,title,opacity=0,frameLabel=null}){
  ctx.save();
  // This is anchored to the video, independently of the court's OB transform.
  ctx.setTransform(1,0,0,1,0,0);
  if(frameLabel){
    ctx.font='700 12px Arial';ctx.textAlign='right';ctx.textBaseline='bottom';
    const boxWidth=ctx.measureText(frameLabel).width+14;
    ctx.fillStyle='rgba(255,255,255,0.92)';ctx.fillRect(width-boxWidth-8,height-29,boxWidth,21);
    ctx.fillStyle='#000';ctx.fillText(frameLabel,width-15,height-12);
  }
  if(opacity>0){
    ctx.globalAlpha=opacity;ctx.fillStyle='#fff';ctx.fillRect(0,0,width,height);
    const text=String(title||'OpenDraw').trim()||'OpenDraw';
    let fontSize=28,lines;
    do{ctx.font=`700 ${fontSize}px Arial`;lines=wrapTitle(ctx,text,width*.8);if(lines.length<=4 || fontSize===12)break;fontSize-=2;}while(fontSize>=12);
    if(lines.length>4){lines=lines.slice(0,4);lines[3]=lines[3].slice(0,-1)+'…';}
    ctx.fillStyle='#000';ctx.textAlign='center';ctx.textBaseline='middle';
    const lineHeight=fontSize*1.35;
    lines.forEach((line,index)=>ctx.fillText(line,width/2,height/2+(index-(lines.length-1)/2)*lineHeight));
  }
  ctx.restore();
}
